import { Box, Grid, Modal, Typography } from "@mui/material";
import { ModalHeader } from "../../common/modalHeader";
import { useEffect, useState } from "react";
import { Padding } from "@mui/icons-material";
import { GetBussiness } from "../myBusiness/myBusinessApi";
import { useDispatch, useSelector } from "react-redux";

export const TimeModal = ({ open, setOpen, date, data }) => {
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const dispatch = useDispatch();

  const [cll, setcll] = useState([]);
  useEffect(() => {
    console.log("cll===== ", cll);
  }, [cll])
  useEffect(() => {
    console.log("date ", date);
  }, []);

















  useEffect(() => {
    getTime("08:30 am", "09:00 pm");

  }, [])
  const [timeConfig, setTimeConfig] = useState({
    openingTime: 0,
    closingTime: 0,
  });
  const getData = async () => {
    await GetBussiness()
      .then((res) => {
        console.log("es.data.data[0] ", res?.data?.data[0]);
        let obj = { ...res?.data?.data[0] };
        console.log("jonkkk=========", obj)
        getTime(obj?.openingTime, obj?.closingTime);
        // setTimeConfig({
        //   openingTime: obj?.openingTime,
        //   closingTime: obj?.closingTime
        // })
      })
      .catch((err) => {
        console.log("err ", err);
      });
  };

  function generateTimeSlots(start, end) {
    const result = [];

    // Convert to 24-hour time for easier comparison
    const to24Hour = (hour, noon) => {
      if (noon.toLowerCase() === "pm" && hour !== 12) return hour + 12;
      if (noon.toLowerCase() === "am" && hour === 12) return 0;
      return hour;
    };

    let hour = start.hour;
    let min = start.min;
    let noon = start.noon;

    while (true) {
      // Format minutes to always have two digits
      result.push({
        hour,
        min: min.toString().padStart(2, "0"),
        noon
      });

      // Add 30 minutes
      min += 30;
      if (min >= 60) {
        min -= 60;
        hour += 1;

        // Handle noon transition
        if (hour === 12) {
          noon = noon === "am" ? "pm" : "am";
        }
        if (hour > 12) hour = 1;
      }

      // Check if current time reached or passed the endpoint
      const current24 = to24Hour(hour, noon) * 60 + min;
      const end24 = to24Hour(end.hour, end.noon) * 60 + end.min;
      if (current24 > end24) break;
    }

    return result;
  }

  function parseTime(timeStr) {
    // Allow optional whitespace before am/pm
    const withColon = timeStr.match(/^(\d{1,2}):(\d{2})\s*([aApP][mM])$/);
    const withoutColon = timeStr.match(/^(\d{1,2})(\d{2})\s*([aApP][mM])$/);
    const onlyHour = timeStr.match(/^(\d{1,2})\s*([aApP][mM])$/);

    if (withColon) {
      return {
        hour: parseInt(withColon[1]),
        min: parseInt(withColon[2]),
        noon: withColon[3].toLowerCase(),
      };
    } else if (withoutColon) {
      return {
        hour: parseInt(withoutColon[1]),
        min: parseInt(withoutColon[2]),
        noon: withoutColon[3].toLowerCase(),
      };
    } else if (onlyHour) {
      return {
        hour: parseInt(onlyHour[1]),
        min: 0,
        noon: onlyHour[2].toLowerCase(),
      };
    } else {
      return { error: "Invalid time format" };
    }
  }

  const getTime = (openingTime, closingTime) => {
    let opningTime = parseTime(openingTime);
    let closingTIme = parseTime(closingTime);
    setcll(generateTimeSlots(opningTime, closingTIme));
  };

  useEffect(() => {
    if (userDetail && Object.keys(userDetail).length > 0) {
      getData();
    }
    // getData();
  }, [userDetail]);
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        // setFormData({ ...struct })
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "50%", md: "60%", lg: "40%", xl: "40%" },

          height: "80vh",
          overflowY: "auto",
          position: "absolute",
          left: { xs: "2%", sm: "30%", md: "25%", lg: "30%", xl: "30%" },

          top: "10%",
          borderRadius: "10px",
        }}
      >
        <ModalHeader title="Appointment Time" onClose={() => setOpen(false)} />

        <Grid container mt={3} px={2}>
          {cll?.map((ele, index) => {
            return (
              <Grid xs={6} sm={4} key={"dd" + index}>
                <Box
                  style={{
                    padding: "10px",
                    margin: "5px",
                    border: "2px solid #01008BA8",
                    borderRadius: "5px",
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    date({
                      ...ele,
                      noon: ele.noon.toUpperCase(),
                    });
                  }}
                >
                  <Typography
                    sx={{
                      cursor: "pointer",
                      textTransform: "uppercase",
                      color: "#01008B",
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      fontWeight: 500,
                    }}
                  >
                    {`${ele?.hour} : ${ele?.min} ${ele?.noon}`}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Modal>
  );
};
